import {
  DataFromStorageSetter,
  IPendingConfigStorage,
  ISettingsStorage,
} from "@/services/storage/base/storage-abstractions";
import React from "react";
import { TextToMusicSettingsStorageMixin } from "@/services/storage/storage-mixins/settings-mixins/text-to-music-settings-storage-mixin";
import { TextToMusicSettings } from "@/components/pages/text-to-music/components/providers/text-to-music-provider";
import { PendingConfigStorageMixin } from "@/services/storage/storage-mixins/pending-config-storage-mixin";
import { TextToMusicConfig } from "@/components/pages/text-to-music/hooks/use-start-text-to-music";

export type TextToMusicSettingsField = "text" | "trackLength";

class TextToMusicSessionStorage
  implements
    ISettingsStorage<TextToMusicSettingsField>,
    IPendingConfigStorage<TextToMusicConfig>,
    DataFromStorageSetter<TextToMusicSettings>
{
  private storeName = "textToMusicCache";
  private databaseName = "TextToMusicDB";

  pendingConfigStorage = new PendingConfigStorageMixin<TextToMusicConfig>(
    this.storeName,
    this.databaseName,
  );

  settingStorage = new TextToMusicSettingsStorageMixin(
    this.storeName,
    this.databaseName,
  );

  async setDataFromStorage(
    setSettings: (value: React.SetStateAction<TextToMusicSettings>) => void,
  ): Promise<void> {
    const sessionSettings = await this.settingStorage.getSettings();

    setSettings((prevState) => ({
      ...prevState,
      text: sessionSettings.text,
      trackLength: sessionSettings.trackLength,
    }));
  }
}

const textToMusicSessionStorage = new TextToMusicSessionStorage();
export { textToMusicSessionStorage };
